import { Pipe, PipeTransform } from '@angular/core';
import { DeviceModel } from '../models/centrex/device-model';
import { Device } from '../models/centrex/device';

@Pipe({
    name: 'deviceModelDisplay',
    standalone: true
})
export class DeviceModelDisplayPipe implements PipeTransform {

  transform(device: any, isModelDevice: boolean = true): string {
    if (isModelDevice) {
      device = device as DeviceModel;
      return device ? device.manufacturer + ' - ' + device.name : '';
    } else if (device as Device) {
      return device ? device.manufacturer + ' - ' + device.modelName : '';
    } else {
      return '';
    }
  }

}
